export const events = {
  addWorkArea: 'Add workarea',
  editWorkArea: 'Edit workarea',
  addSpace: 'Add space',
  editSpace: 'Edit space',
  publishWorkArea: 'Publish workarea',
  deleteWorkArea: 'Delete workarea',
  publishSpace: 'Publish space',
  deleteSpace: 'Delete space',
  cancelSpace: 'Cancel space',
  seeBookings: 'Go to spaces bookings',
  seeOverview: 'Go to spaces overview',

  bookings: {
    addBooking: 'Add booking',
    filterAvailability: 'Filter space availability',
    filterReset: 'Reset filters',
    publishBooking: 'Publish booking',
    deleteBooking: 'Delete booking',
    editBooking: 'Edit booking',
    cancelBooking: 'Cancel booking',
    filterBookings: 'Filter bookings',
    requestExportBooking: 'Request export booking',
  },
}
